import styles from '~/shared/components/Hero5050Component/Hero5050Component.module.scss';
import { Link, Countdown } from '~/shared/components';
import { M13Countdown5050Module } from '~/lib/data-contract/auto-generated/api-model';
import { useCallback, useMemo, useState } from 'react';
import { DynamicImageLoader } from '~/shared/components/DynamicImageLoader';

import Hero5050Component from '~/shared/components/Hero5050Component/Hero5050Component';

type M13Countdown5050ModuleProps = M13Countdown5050Module;

const M13Countdown5050ModuleComponent = ({
    startImage,
    endImage,
    startImageimageAltText,
    endImageimageAltText,
    countdownEndDate,
    ...moduleProps
}: M13Countdown5050ModuleProps) => {
    const [countdownEnds, setCountdownEnds] = useState(false);

    const handleCountdownExpire = useCallback(() => {
        setCountdownEnds(true);
    }, []);

    const media = useMemo(() => {
        if (!startImage?.src && !endImage?.src) return null;

        const imageElement = (
            <DynamicImageLoader
                className={styles.image}
                src={countdownEnds ? endImage?.src ?? '' : startImage?.src ?? ''}
                width={520}
                height={390}
                alt={countdownEnds ? endImageimageAltText ?? '' : startImageimageAltText ?? ''}
                priority={moduleProps?.aboveTheFold}
            />
        );

        if (moduleProps?.link?.url) {
            return (
                <Link
                    title={moduleProps?.link.title}
                    noHover
                    href={moduleProps?.link.url}
                    target={moduleProps?.link.target}
                    className={styles.linkWrapper}
                >
                    {imageElement}
                </Link>
            );
        }

        return <div className={styles.linkWrapper}>{imageElement}</div>;
    }, [
        moduleProps?.aboveTheFold,
        startImage?.src,
        endImage?.src,
        startImageimageAltText,
        endImageimageAltText,
        moduleProps?.link,
        moduleProps?.title,
        countdownEnds,
    ]);

    return (
        <Hero5050Component
            {...moduleProps}
            media={media}
            countDownTimer={
                countdownEndDate ? (
                    <Countdown
                        variant="hero"
                        endDate={countdownEndDate}
                        onExpire={handleCountdownExpire}
                    />
                ) : null
            }
            countDownEnds={countdownEnds}
        />
    );
};

export default M13Countdown5050ModuleComponent;
